import React from 'react';
import { Link } from 'react-router-dom';
import { useLocale } from '../../contexts/LocaleContext';
import { themeClasses } from '../../config/themeClasses';
import BrandLogo from '../Brand/BrandLogo';
import ThemeToggle from './ThemeToggle';
import { Button } from '../UI/button';

export default function LandingLayout({ children }) {
  const { t } = useLocale();

  return (
    <div className={themeClasses.landing.page}>
      <header className={themeClasses.landing.navBar}>
        <div className={`${themeClasses.landing.containerWide} flex h-16 items-center justify-between`}>
          <BrandLogo name={t('appName')} to="/" />
          <div className="flex items-center gap-2 sm:gap-3">
            <ThemeToggle />
            <Button variant="default" size="sm" asChild>
              <Link to="/login">{t('landingNavLogin')}</Link>
            </Button>
          </div>
        </div>
      </header>
      <main>{children}</main>
    </div>
  );
}
